import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: { main: '#0d9488', dark: '#0f766e', light: '#5eead4', contrastText: '#ffffff' },
        secondary: { main: '#0b1220' },
        background: { default: '#ffffff', paper: '#ffffff' },
        text: { primary: '#0f172a', secondary: '#475569' },
    },
    typography: {
        fontFamily: '"Inter", "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
        h1: { fontWeight: 800, letterSpacing: '-0.02em' },
        h2: { fontWeight: 800, letterSpacing: '-0.02em' },
        h3: { fontWeight: 700 },
        h6: { fontWeight: 700 },
        button: { textTransform: 'none', fontWeight: 600 },
    },
    shape: { borderRadius: 12 },
    components: {
        MuiPaper: { defaultProps: { elevation: 0 } },
        MuiButton: { defaultProps: { disableElevation: true } },
    },
});

export default theme;
